export enum ServiceExtensions {
	LayoutRules = 'layout_rules',
	MasterRules = 'master_rules'
}